import { apiEndpoints } from './common'

import { get } from '../request'

// Live preschool daily-updates compliance audit for a single date.
// Returns { rows, absentees } — same shape the page previously read from the
// static /audit-data/parent-updates-<date>.json files.
export const getPreschoolUpdatesForDate = async (date) => {
  const response = await get(apiEndpoints.preschoolUpdatesAudit, {
    params: { date }
  })
  return response.data
}

// Live per-teacher compliance trend over a rolling window (defaults to the
// last 30 days server-side when from/to are omitted). Returns { dates, byDate }
// — the same shape the Trend tab previously read from the static
// teacherTrends.json (rosters/centre still come from that static file).
export const getPreschoolTeacherTrends = async (params = {}) => {
  const response = await get(apiEndpoints.preschoolUpdateTrends, { params })
  return response.data
}

// Live per-centre compliance trend over a rolling window (defaults to the last
// 30 days server-side). Returns { dates, byDate } — the same shape the Audits
// Trends tab previously read from the static /audit-data/trends.json.
export const getPreschoolCentreTrends = async (params = {}) => {
  const response = await get(apiEndpoints.preschoolCentreTrends, { params })
  return response.data
}
